import {Button, Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {anonymizeUserModalState, close as anonymizeUserModalClose, setEmailChecked} from "./AnonymizeUserModalSlice";
import {anonymizeUser as anonymizeUserAction} from "../../UsersSlice";

const AnonymizeUserModal = () => {
  const dispatch = useDispatch();
  const {isOpened, user, isEmailChecked} = useSelector(anonymizeUserModalState);
  const handleClose = () => {
    dispatch(anonymizeUserModalClose());
  };
  const checkEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
    dispatch(setEmailChecked(event.currentTarget.value === user?.adminEmail));
  };
  const handleAnonymizeUser = () => {
    dispatch(anonymizeUserAction(user!));
  };
  return (
    <Modal show={isOpened} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Anonymize user (company)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>Anonymize user (company) with all login users and clear the cache</div>
        <div>
          Email: <span className="font-weight-bold">{user?.adminEmail}</span>
        </div>
        <div>
          Id: <span className="font-weight-bold">{user?.id}</span>
        </div>
        <div>
          Email address:
          <input type="email" className="form-control" id="email" onKeyUp={checkEmail} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button className="btn btn-danger" disabled={!isEmailChecked} onClick={handleAnonymizeUser}>
          Anonymize login user
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AnonymizeUserModal;
